var React = require('react');

function AppendixA (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 1.25A2.75 2.75 0 0 0 3.25 4v15A2.75 2.75 0 0 0 6 21.75h12A2.75 2.75 0 0 0 20.75 19V4A2.75 2.75 0 0 0 18 1.25H6zM4.75 4c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v15c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25V4zM9 6.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H9zM8.25 11a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75zM9 14.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H9z","fill":"#fff"}));
}

AppendixA.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = AppendixA;

AppendixA.default = AppendixA;
